import React, { useState, useEffect } from 'react';
import styles from './UserManagement.module.css';

const defaultPermissions = {
  form: [
    { name: 'Form Görüntüleme', description: 'Formları görüntüleme yetkisi', granted: false },
    { name: 'Form Oluşturma', description: 'Yeni form oluşturma yetkisi', granted: false },
    { name: 'Form Düzenleme', description: 'Mevcut formları düzenleme yetkisi', granted: false },
    { name: 'Form Silme', description: 'Formları silme yetkisi', granted: false }
  ],
  user: [
    { name: 'Kullanıcı Görüntüleme', description: 'Kullanıcıları görüntüleme yetkisi', granted: false },
    { name: 'Kullanıcı Ekleme', description: 'Yeni kullanıcı ekleme yetkisi', granted: false },
    { name: 'Kullanıcı Düzenleme', description: 'Kullanıcı bilgilerini düzenleme yetkisi', granted: false },
    { name: 'Kullanıcı Silme', description: 'Kullanıcıları silme yetkisi', granted: false }
  ]
};

const UserPermissionModal = ({ open, user, onClose, onSave }) => {
  const [permissions, setPermissions] = useState(defaultPermissions);

  useEffect(() => {
    if (user?.permissions && Array.isArray(user.permissions.form) && Array.isArray(user.permissions.user)) {
      setPermissions(user.permissions);
    } else {
      setPermissions(defaultPermissions);
    }
  }, [user]);

  const handlePermissionChange = (category, index) => {
    setPermissions(prev => ({
      ...prev,
      [category]: prev[category].map((perm, i) => 
        i === index ? { ...perm, granted: !perm.granted } : perm
      )
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!user?.id) {
      console.error('Kullanıcı ID bulunamadı');
      return;
    }
    onSave({
      userId: user.id,
      permissions
    });
  };

  if (!open || !user) {
    return null;
  }

  return (
    <div className={styles.modal}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>İzin Yönetimi</h2>
          <button className={styles.closeButton} onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className={styles.permissionSection}>
            <h3 className={styles.sectionTitle}>Form İzinleri</h3>
            <div className={styles.permissionList}>
              {Array.isArray(permissions.form) && permissions.form.map((permission, index) => (
                <div key={index} className={styles.permissionItem}>
                  <label className={styles.permissionLabel}>
                    <input
                      type="checkbox"
                      checked={permission.granted}
                      onChange={() => handlePermissionChange('form', index)}
                    />
                    <span>{permission.name}</span>
                  </label>
                  <p className={styles.permissionDescription}>
                    {permission.description}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className={styles.permissionSection}>
            <h3 className={styles.sectionTitle}>Kullanıcı İzinleri</h3>
            <div className={styles.permissionList}>
              {Array.isArray(permissions.user) && permissions.user.map((permission, index) => (
                <div key={index} className={styles.permissionItem}>
                  <label className={styles.permissionLabel}>
                    <input
                      type="checkbox"
                      checked={permission.granted}
                      onChange={() => handlePermissionChange('user', index)}
                    />
                    <span>{permission.name}</span>
                  </label>
                  <p className={styles.permissionDescription}>
                    {permission.description}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className={styles.modalActions}>
            <button
              type="button"
              className={`${styles.button} ${styles.secondaryButton}`}
              onClick={onClose}
            >
              İptal
            </button>
            <button
              type="submit"
              className={`${styles.button} ${styles.primaryButton}`}
            >
              Kaydet
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UserPermissionModal; 